import { ActionType, getType } from 'typesafe-actions';
import * as actions from '@actions/fhq-general-settings';
import { ResultState } from '@rootCommon/types/common';
import { FhqGeneralSetting } from '@rootCommon/types/fhq';

type Action = ActionType<typeof actions>;
export type FhqGeneralSettingState = ResultState<FhqGeneralSetting | null>;

const initState: FhqGeneralSettingState = {
  data: null,
  loading: false,
  error: null,
};

export const fhqGeneralSettingsReducer = (state = initState, action: Action): FhqGeneralSettingState => {
  switch (action.type) {
    // fetch
    case getType(actions.fetchFhqGeneralSettings.request):
      return { ...state, loading: true };
    case getType(actions.fetchFhqGeneralSettings.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.fetchFhqGeneralSettings.failure):
      return { ...state, loading: false, error: action.payload };

      // update
    case getType(actions.updateFhqGeneralSettings.request):
      return { ...state, loading: true };
    case getType(actions.updateFhqGeneralSettings.success):
      return { ...state, loading: false, data: action.payload };
    case getType(actions.updateFhqGeneralSettings.failure):
      return { ...state, loading: false, error: action.payload };

    case getType(actions.setGeneralSettingsIsLoading):
      return { ...state, loading: true };

    default:
      return state;
  }
};

export default fhqGeneralSettingsReducer;
